{
  "title": "Расходы",
  "intro": "Сколько стоит проект в этом месяце и сколько будет стоить к его концу, по видам ресурсов, по дням и по месяцам.",
  "orgIntro": "Расходы всех проектов организации: с начала месяца, прогноз до его конца, по видам ресурсов и по дням.",
  "estimate": "Это наша оценка, а не счёт: суммы без НДС, посчитаны по каждому начатому часу по прайс-листу провайдера, но не больше месячной цены ресурса. Счёт Hetzner может немного отличаться.",
  "meteredAt": "Последний расчёт: {{time}}",
  "notMetered": "Расчёт ещё не выполнялся: первые суммы появятся через несколько минут.",
  "month": "Месяц",
  "export": "Скачать CSV",
  "monthToDate": "С начала месяца",
  "monthTotal": "За месяц",
  "forecast": "Прогноз на месяц",
  "forecastHint": "Сумма с начала месяца плюс всё, что есть в проекте сейчас, до конца месяца — не больше месячной цены каждого ресурса. Трафик сверх включённого не прогнозируется.",
  "lastMonth": "Прошлый месяц",
  "projects": "Проекты",
  "project": "Проект",
  "noProjects": "Проектов пока нет",
  "noProjectsLead": "Подключите проект Hetzner — его расходы начнут считаться каждый час.",
  "byKind": "По видам ресурсов",
  "byDay": "По дням",
  "byMonth": "По месяцам",
  "dayAmount": "За день",
  "monthAmount": "За месяц",
  "chartEmpty": "За этот период расходов нет.",
  "top": "Самое дорогое",
  "resources": "Всё, что оплачивалось в этом месяце",
  "resource": "Ресурс",
  "kind": "Вид",
  "amount": "Сумма без НДС",
  "deleted": "удалён",
  "empty": "В этом месяце расходов нет.",
  "emptyLead": "Как только в проекте появятся платные ресурсы — серверы, адреса, диски, снимки, — их расходы начнут считаться каждый час.",
  "open": "Открыть расходы",
  "kinds": {
    "server": "Серверы",
    "backup": "Резервные копии",
    "traffic": "Трафик сверх включённого",
    "public_ip": "Публичные IPv4",
    "floating_ip": "Плавающие IP",
    "volume": "Диски",
    "snapshot": "Снимки",
    "load_balancer": "Балансировщики"
  },
  "appliance": "Прибор: {{name}}"
}
